import { FILE_TYPE, } from '../model/PadInfo';
import { TOC_ORIGIN } from "../config";
var _window = window;
/*
 * @Author: freedeng
 * @Date: 2019-06-13 22:34:03
 * @Last Modified by: freedeng
 * @Last Modified time: 2019-07-04 17:38:38
 */
function getCookie(key) {
    var m = document.cookie.match(new RegExp("(^| )" + key + "=([^;]*)(;|$)"));
    return !m ? '' : decodeURIComponent(m[2]);
}
function setCookie(name, value, domain, path, hour) {
    var expire = new Date();
    expire.setTime(expire.getTime() + (hour ? 3600000 * hour : 30 * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + "; " + ("expires=" + expire.toUTCString() + "; path=" + (path || '/') + "; " + (domain ? "domain=" + domain + ";" : ''));
}
function getXsrf() {
    return getCookie('TOK') || '';
}
function getQuery(n) {
    var m = window.location.search.match(new RegExp("(\\?|&)" + n + "=([^&]*)(&|$)"));
    return !m ? '' : decodeURIComponent(m[2]);
}
function pushState(url, replace) {
    var history = window.history;
    try {
        if (replace) {
            history.replaceState(null, '', url);
        }
        else {
            history.pushState(null, '', url);
        }
    }
    catch (e) {
        window.location[replace ? 'replace' : 'assign'](url);
    }
}
var UserAgent = (function () {
    var ua = navigator.userAgent.toLowerCase();
    var isPad = /(ipad)/i.test(ua);
    var isMobile = /(mobile)/i.test(ua) && !isPad;
    var isDesktop = /(TDAppDesktop)/.test(navigator.userAgent);
    var userAgent = {
        isPad: isPad,
        isMobile: isMobile,
        isDesktop: isDesktop,
    };
    return userAgent;
})();
function numToString(num) {
    return num.toString(36).toLowerCase();
}
function ChangesetPack(csInfo) {
    var lenDiff = csInfo.newLen - csInfo.oldLen;
    var lenDiffStr = lenDiff >= 0 ? ">" + numToString(lenDiff) : "<" + numToString(-lenDiff);
    return "Z:" + numToString(csInfo.oldLen) + lenDiffStr + csInfo.opsStr + "$" + csInfo.charBank;
}
/**
 * 是否支持客户端DB
 */
function isSupportClientDB() {
    var offlineSwitch = localStorage.getItem('OFFLINE_DB_SWITCH');
    if (offlineSwitch === '0') {
        return false;
    }
    var tdocFlag = navigator.userAgent.match(/_tdocFlag\/(\d+)/);
    if (tdocFlag && tdocFlag[1]) {
        var num = parseInt(tdocFlag[1]);
        return num & (1 << 1);
    }
    return false;
}
/**
 * 用于浏览器下调试离线
 */
function checkDebugOffline() {
    var debug = getQuery('offline-debug');
    if (debug === '1') {
        return true;
    }
    return false;
}
/**
 * word 离线包开关
 *
 * @returns
 */
function wordOfflineSwitch() {
    if (_window.App && _window.App.GlobalConfig && _window.App.GlobalConfig.IsSupportStore) {
        return true;
    }
    return false;
}
function wordCodeVersion() {
    if (_window.App && _window.App.GlobalConfig && _window.App.GlobalConfig.globalCodeVersion) {
        return _window.App.GlobalConfig.globalCodeVersion;
    }
    return '';
}
/**
 * 包一下data   因为有些数据是从数据库直接读出来的  实际上不是对象 只是普通Object 没有相应的方法，wrap之后 就有方法了
 * @param data
 * @param targetClassType 目标类  只有目标类的实例 才会进行wrap
 */
function wrapData(data, targetClassType) {
    if (Array.isArray(data)) {
        return data.map(function (item) { return new targetClassType.prototype.constructor(item); });
    }
    return new targetClassType.prototype.constructor(data);
}
/**
 * 包裹IndexedDB查询结果
 * @param classType 要包裹的类的构造函数
 */
function wrapResult(result, classType) {
    result.data = wrapData(result.data, classType);
    return result;
}
function parseString(text) {
    if (typeof text === 'string') {
        var ret = JSON.parse(text);
        return parseString(ret);
    }
    return text;
}
function deserializeMutation(data) {
    var urls = [];
    if (data.v >= 5) {
        var res = data.c;
        if (res[0] === 'IMAGE' || (typeof (res[2]) === 'string' && res[2].indexOf('attachment-') !== -1)) {
            urls.push(data.c[3]);
        }
    }
    return urls;
}
function getCollabMutations(mutationsParams) {
    var urls = [];
    var tempParams;
    if (typeof mutationsParams === 'string') {
        tempParams = JSON.parse(mutationsParams);
    }
    if (Array.isArray(tempParams)) {
        tempParams.forEach(function (data) {
            if (!data || !data.v) {
                return;
            }
            urls = urls.concat(deserializeMutation(data));
        });
    }
    return urls;
}
function k2sConverter(text) {
    var urls = [];
    for (var i = 0, iLen = text.length; i < iLen; i++) {
        var actions = parseString(text[i]);
        for (var j = 0, jLen = actions.length; j < jLen; j++) {
            var action = actions[j];
            if (action.v) {
                urls = urls.concat(deserializeMutation(action));
            }
            else {
                urls = urls.concat(getCollabMutations(action));
            }
        }
    }
    return urls;
}
var getFileType = function (type) {
    var fileType = FILE_TYPE.UNKNOWN;
    if (type === 'doc') {
        fileType = FILE_TYPE.WORD;
    }
    else if (type === 'sheet') {
        fileType = FILE_TYPE.EXCEL;
    }
    else if (type === 'slide') {
        fileType = FILE_TYPE.SLIDE;
    }
    return fileType;
};
var getFileTypeName = function (fileType) {
    var fileTypeName;
    if (fileType === FILE_TYPE.WORD) {
        fileTypeName = 'doc';
    }
    else if (fileType === FILE_TYPE.EXCEL) {
        fileTypeName = 'sheet';
    }
    else if (fileType === FILE_TYPE.SLIDE) {
        fileTypeName = 'slide';
    }
    return fileTypeName;
};
var reconstructDocUrl = function (fileType, secretId) {
    var type = getFileTypeName(fileType);
    return TOC_ORIGIN + "/" + type + "/" + secretId;
};
function logSyncResult(result) {
    var _a;
    if (!result) {
        return 'result is undefine!!!';
    }
    return "result is { resultCode: " + result.resultCode + " subResultCode: " + result.subResultCode + " message: " + result.message + " dataUndefinedCheck: " + (result.data === undefined) + " error: " + ((_a = result.error) === null || _a === void 0 ? void 0 : _a.stack) + "}";
}
var getUserId = function () {
    var _a, _b;
    // 多账号环境下 cookie 中没有 uid
    return getCookie('uid') || ((_b = (_a = global.basicClientVars) === null || _a === void 0 ? void 0 : _a.userInfo) === null || _b === void 0 ? void 0 : _b.tinyId) || '';
};
export { getCookie, setCookie, getXsrf, pushState, UserAgent, ChangesetPack, isSupportClientDB, wordOfflineSwitch, checkDebugOffline, wordCodeVersion, wrapResult, k2sConverter, getCollabMutations, logSyncResult, getFileType, getFileTypeName, reconstructDocUrl, getUserId, };
//# sourceMappingURL=utils.js.map